<template>
  <!-- element-loading-text="excle导入中，请稍等" -->
  <div class="app-container">
    <!-- 编辑弹框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="70%">
      <el-form
        ref="addForm"
        label-position="right"
        :model="addForm"
        :rules="rules"
        label-width="150px"
      >
        <el-form-item label="id" prop="text" v-if="addForm._id">
          <el-input v-model="addForm._id" :disabled="!!addForm._id"></el-input>
        </el-form-item>
        <el-form-item label="分类" prop="text">
          <el-select v-model="addForm.cate" placeholder="请选择">
            <el-option
              v-for="item in pcates.filter(v=>v.level==1)"
              :key="item._id"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="二级分类" prop="text">
          <el-select v-model="addForm.second_cate" placeholder="请选择">
            <el-option
              v-for="item in pcates.filter(v=>v.level==2)"
              :key="item._id"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分类" prop="text">
          <el-select v-model="addForm.cate" placeholder="请选择">
            <el-option v-for="item in pcates" :key="item._id" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产品名称" prop="text">
          <el-input v-model="addForm.name"></el-input>
        </el-form-item>
        <!-- <el-form-item label="产品价格" prop="text">
          <el-input v-model.number="addForm.price"></el-input>
        </el-form-item>
        <el-form-item label="产品描述" prop="text">
          <el-input v-model="addForm.keys"></el-input>
        </el-form-item>-->
        <el-form-item label="是否显示" prop="text">
          <el-switch v-model="addForm.isShow" active-text="显示" inactive-text="不显示"></el-switch>
        </el-form-item>
        <el-form-item label="显示顺序" prop="text">
          <el-input-number v-model="addForm.rankProduct" :min="1" :max="1000" label="越大排名越前"></el-input-number>
        </el-form-item>
        <el-form-item label="首页显示顺序" prop="text">
          <el-input-number v-model="addForm.rankHot" :min="1" :max="1000" label="越大排名越前"></el-input-number>
        </el-form-item>
        <el-form-item label="是否显示在首页" prop="text">
          <el-switch v-model="addForm.isHot" active-text="显示" inactive-text="不显示"></el-switch>
        </el-form-item>

        <!-- 产品参数 -->
        <el-form-item label="包装信息" prop="text">
          <el-col :span="20" v-for=" (item,index) in addForm.parameter" :key="index">
            <el-row>
              <el-col :span="10">
                <el-select size="small" v-model="addForm.parameter[index].label" placeholder="请选择">
                  <el-option
                    v-for="item2 in pparam"
                    :key="item2._id"
                    :label="item2.name"
                    :value="item2.name"
                  ></el-option>
                </el-select>
              </el-col>
              <el-col :span="10">
                <el-input size="small" v-model="addForm.parameter[index].value"></el-input>
              </el-col>
              <el-col :span="2" :offset="1">
                <el-button type="danger" size="mini" @click="deleteParam(item)">删除</el-button>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="24">
            <el-button size="mini" type="primary" @click="addParams">添加</el-button>
          </el-col>
        </el-form-item>
        <!-- 产品包装 -->
        <el-form-item label="产品参数" prop="text">
          <el-col :span="20" v-for=" (item,index) in addForm.packages" :key="index">
            <el-row>
              <el-col :span="10">
                <el-select size="small" v-model="addForm.packages[index].label" placeholder="请选择">
                  <el-option
                    v-for="item2 in ppkg"
                    :key="item2._id"
                    :label="item2.name"
                    :value="item2.name"
                  ></el-option>
                </el-select>
              </el-col>
              <el-col :span="10">
                <el-input size="small" v-model="addForm.packages[index].value"></el-input>
              </el-col>
              <el-col :span="2" :offset="1">
                <el-button type="danger" size="mini" @click="deletePkg(item)">删除</el-button>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="24">
            <el-button size="mini" type="primary" @click="addPkg">添加</el-button>
          </el-col>
        </el-form-item>
        <!-- 产品亮点 -->
        <el-form-item label="产品亮点" prop="text">
          <el-col :span="20" v-for=" (item,index) in addForm.sellPoint" :key="index">
            <el-row>
              <el-col :span="15">
                <el-input size="small" v-model="addForm.sellPoint[index]"></el-input>
              </el-col>
              <el-col :span="2" :offset="1">
                <el-button type="danger" size="mini" @click="deletePoint(item)">删除</el-button>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="24">
            <el-button size="mini" type="primary" @click="addPoint">添加</el-button>
          </el-col>
        </el-form-item>

        <!-- 产品外链 -->
        <el-form-item label="产品外链" prop="text">
          <el-col :span="20" v-for=" (item,index) in addForm.shareLink" :key="index">
            <el-row>
              <el-col :span="10">
                <el-select size="small" v-model="addForm.shareLink[index].label" placeholder="请选择">
                  <el-option
                    v-for="(item2,_index) in pshareIcons"
                    :key="_index"
                    :label="item2"
                    :value="item2"
                  ></el-option>
                </el-select>
              </el-col>
              <el-col :span="10">
                <el-input size="small" v-model="addForm.shareLink[index].value"></el-input>
              </el-col>
              <el-col :span="2" :offset="1">
                <el-button type="danger" size="mini" @click="deleteSharelink(item)">删除</el-button>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="24">
            <el-button size="mini" type="primary" @click="addSharelink">添加</el-button>
          </el-col>
        </el-form-item>

        <el-form-item label="产品图片" prop="cover">
          <el-upload
            class="upload-demo"
            :action="picbaseurl"
            :on-remove="handleCoverRemove"
            :file-list="coverFileList"
            :on-success="handleCoverUpload"
            list-type="picture"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="产品视频" prop="cover">
          <el-upload
            class="upload-demo"
            :action="picbaseurl"
            :on-remove="handleVideoRemove"
            :file-list="videoFileList"
            :limit="1"
            :on-success="handleVideoUpload"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传视频文件</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="产品轮播图" prop="imgs">
          <el-upload
            class="upload-demo"
            :action="picbaseurl"
            :on-remove="handleImgsRemove"
            :file-list="imgs_tool"
            :on-success="handleImgsUpload"
            list-type="picture"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogConfirmButtonClick('addForm')">确 定</el-button>
        <el-button type="primary" @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>

    <el-card class="box-card" v-loading="loading" element-loading-spinner="el-icon-loading">
      <div slot="header" class="clearfix">
        <el-button
          type="primary"
          size="mini"
          icon="el-icon-circle-plus-outline"
          round
          :style="{float:'right',marginTop:'10px'}"
          @click="addItem"
        >新增</el-button>
      </div>
      <div class="content">
        <el-table :data="tdata" border style="width: 100%">
          <el-table-column type="index" width="50" align="center"></el-table-column>
          <el-table-column prop="name" label="产品名称" align="center"></el-table-column>

          <el-table-column prop="isShow" label="是否显示" align="center">
            <template slot-scope="scope">
              {{
              scope.row.isShow?'显示':"不显示"
              }}
            </template>
          </el-table-column>
          <el-table-column prop="isHot" label="是否显示在首页" align="center">
            <template slot-scope="scope">
              {{
              scope.row.isHot?'显示':"不显示"
              }}
            </template>
          </el-table-column>
          <el-table-column prop="cate" label="分类" align="center"></el-table-column>
          <el-table-column prop="cover" label="产品图片" align="center">
            <template slot-scope="scope">
              <img :src="scope.row.cover" width="100" alt />
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="220" align="center">
            <template slot-scope="scope">
              <el-button type="primary" @click="handleEdit(scope.row)" size="mini">编辑</el-button>
              <el-button type="danger" @click="handleDelete(scope.row)" size="mini">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
  </div>
</template>

<script>
import { constants } from "crypto";
export default {
  data() {
    return {
      dialogVisible: false,
      dialogTitle: "新增",
      coverFileList: [],
      videoFileList: [],
      imgs_tool: [],
      pshareIcons: ["faceBook", "whatApp", "inst", "twiter"],

      pcates: [],
      pparam: [],
      ppkg: [],
      defaultForm: {
        name: "",
        cate: "",
        second_cate: "",
        isHot: true,
        isShow: true,
        keys: "",
        imgs: [],
        cover: "",
        video: "",
        parameter: [],
        sellPoint: [],
        packages: [],
        shareLink: [],
        rankProduct: 1,
        rankHot: 1
      },
      addForm: {},
      loading: false,
      rules: {
        title: [
          {
            required: true,
            message: "请完善信息",
            trigger: "blur"
          }
        ],
        content: [
          {
            required: true,
            message: "请完善信息",
            trigger: "blur"
          }
        ]
      },
      tdata: []
    };
  },

  created() {
    this.initData();
  },
  mounted() {},
  computed: {},
  methods: {
    addParams() {
      this.addForm.parameter.push({
        label: this.pparam[0].name,
        value: ""
      });

      console.log(this.addForm.parameter);
    },
    deleteParam(item) {
      this.addForm.parameter = this.addForm.parameter.filter(
        v => v.value != item.value
      );
    },
    addSharelink() {
      this.addForm.shareLink.push({
        label: this.pshareIcons[0],
        value: ""
      });

      console.log(this.addForm.parameter);
    },
    deleteSharelink(item) {
      this.addForm.shareLink = this.addForm.shareLink.filter(
        v => v.value != item.value
      );
    },
    addPoint() {
      this.addForm.sellPoint.push("");
    },
    deletePoint(item) {
      this.addForm.sellPoint = this.addForm.sellPoint.filter(v => v != item);
    },
    addPkg() {
      this.addForm.packages.push({
        label: this.ppkg[0].name,
        value: ""
      });
    },
    deletePkg(item) {
      this.addForm.packages = this.addForm.packages.filter(
        v => v.value != item.value
      );
    },
    handleCoverUpload(file, fileList) {
      this.coverFileList = [
        {
          name: file.data,
          url: file.data
        }
      ];
      if (this.coverFileList.length > 0) {
        this.addForm.cover = this.coverFileList[0].url;
      }
    },
    handleCoverRemove(file, fileList) {
      this.coverFileList = this.coverFileList.filter(v => v.url != file.url);
    },
    handleVideoUpload(file, fileList) {
      this.videoFileList = [
        {
          name: file.data,
          url: file.data
        }
      ];
      if (this.videoFileList.length > 0) {
        this.addForm.video = this.videoFileList[0].url;
      }
    },
    handleVideoRemove(file, fileList) {
      this.videoFileList = this.videoFileList.filter(v => v.url != file.url);
    },

    handleImgsUpload(file, fileList) {
      console.log(file);
      this.imgs_tool.push({
        name: file.data,
        url: file.data
      });
    },
    handleImgsRemove(file, fileList) {
      this.imgs_tool = this.imgs_tool.filter(v => v.url != file.url);
    },
    addItem() {
      this.dialogVisible = true;
      this.dialogTitle = "新增";
      this.addForm = this.defaultForm;
      this.coverFileList = [];
      this.videoFileList = [];
      this.imgs_tool = [];
    },
    handleEdit(item) {
      this.dialogVisible = true;
      this.dialogTitle = "修改";
      this.addForm = item;

      if (item.cover && item.cover != "") {
        this.coverFileList = [
          {
            name: item.cover,
            url: item.cover
          }
        ];
      }
      if (item.video && item.video != "") {
        this.videoFileList = [
          {
            name: item.video,
            url: item.video
          }
        ];
      }
      if (item.imgs && item.imgs.length > 0) {
        this.imgs_tool = item.imgs.map(v => {
          return { url: v, name: v };
        });
      }
    },
    dialogConfirmButtonClick(formName) {
      if (this.coverFileList.length > 0) {
        this.addForm.cover = this.coverFileList[0].url;
      } else {
        this.addForm.cover = "";
      }
      if (this.videoFileList.length > 0) {
        this.addForm.video = this.videoFileList[0].url;
      } else {
        this.addForm.video = "";
      }

      if (this.imgs_tool.length > 0) {
        this.addForm.imgs = this.imgs_tool.map(v => {
          return v.url;
        });
      } else {
        this.addForm.imgs = [];
      }

      // return console.log(this.addForm);

      this.$refs[formName].validate(valid => {
        if (!valid) {
          return this.$message.error("请检查填写信息是否完整");
        }
        if (this.addForm._id) {
          this.httpPost("/backend/product/upd", this.addForm).then(resp => {
            this.addForm = this.defaultForm;
            this.fileList2 = [];
            if (resp.code == 0) {
              this.$message.success("修改成功", 1000);
              this.initData();
              this.dialogVisible = false;
            } else {
              this.$message.error(resp.msg, 2000);
            }
          });
        } else {
          this.httpPost("/backend/product/add", this.addForm).then(resp => {
            this.addForm = this.defaultForm;
            this.fileList2 = [];
            if (resp.code == 0) {
              this.$message.success("添加成功", 1000);
              this.initData();
              this.dialogVisible = false;
            } else {
              this.$message.error(resp.msg, 2000);
            }
          });
        }
      });
    },
    initData() {
      this.loading = true;

      this.httpPost("/backend/productCate", {}).then(resp => {
        this.pcates = resp.data;
      });
      this.httpPost("/backend/parammeterTag", {}).then(resp => {
        this.pparam = resp.data;
      });
      this.httpPost("/backend/packageTag", {}).then(resp => {
        this.ppkg = resp.data;
      });
      this.httpPost("/backend/product", {}).then(resp => {
        console.log(resp);
        this.loading = false;
        this.tdata = resp.data;
      });
    },

    onEditSubmit(formName) {
      this.$refs[formName].validate(valid => {
        console.log(valid);
        if (valid) {
          api.updateShareDataById(this.form).then(resp => {
            if (resp.rCode != 0) {
              this.$message.error(resp.msg);
            } else {
              this.dialogVisible = false;
              this.form = {};
              this.$message.success("修改成功");
              this.initData();
            }
          });
          console.log(this.form);
        } else {
          this.$message.error("请检查填写信息是否完整");
          return false;
        }
      });
    },
    handleClose() {
      this.dialogVisible = false;
    },
    handleSizeblur(size) {
      this.pquery.size = size;
    },
    handleCurrentblur(page) {
      this.pquery.page = page;
    },
    handleClick(row) {
      this.form = row;
      this.dialogVisible = true;
    },
    handleDelete(row) {
      this.$confirm("请再次确认是否删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error"
      })
        .then(() => {
          this.httpPost("/backend/product/del", { _id: row._id }).then(resp => {
            if (resp.code != 0) {
              this.$message.error("删除失败");
            } else {
              this.initData();
              this.$message.success("删除成功");
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    }
  }
};
</script>

<style scoped>
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
.cell {
  text-align: center;
}
</style>

